export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"color-scheme","content":"light"},{"property":"og:type","content":"website"},{"property":"fb:app_id","content":"408220097039822"},{"name":"google-signin-client_id","content":"809507790477-vbl3ca2m3bh1cod4r5i9fbjghn0p38ga.apps.googleusercontent.com"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Albert+Sans:wght@400;500;600;700&display=swap","media":"print","onload":"this.media='all'"},{"rel":"stylesheet","href":"/theme.min.css"},{"rel":"stylesheet","href":"/icons/icomoon/style.css","media":"print","onload":"this.media='all'"},{"rel":"stylesheet","href":"/icons/icomoon-facilities/style.css","media":"print","onload":"this.media='all'"},{"rel":"stylesheet","href":"https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/css/flag-icons.min.css","media":"print","onload":"this.media='all'"},{"rel":"preconnect","href":"https://www.googletagmanager.com"}],"style":[],"script":[{"innerHTML":"(function(){try{var el=document.documentElement;if(el.getAttribute('data-brand')==='solaire'){el.setAttribute('data-theme','dark');return}var t=localStorage.getItem('tripening-theme')||'system';var d=t==='system'?(window.matchMedia('(prefers-color-scheme:dark)').matches?'dark':'light'):t;el.setAttribute('data-theme',d)}catch(e){}})()","tagPosition":"head"},{"src":"/external.js","defer":true,"async":true}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true